import React from "react";
import {
    FiCheckCircle,
  FiCode,
  FiCloud,
  FiBox,
  FiUsers,
} from "react-icons/fi";

const About: React.FC = () => {


  const highlights = [
    {
      icon: <FiCode className="w-6 h-6" />,
      title: "Desarrollo Full-Stack",
      desc: "Experiencia en frontend y backend con tecnologías modernas",
      color: "blue",
    },
    {
      icon: <FiCloud className="w-6 h-6" />,
      title: "DevOps & Cloud",
      desc: "Infraestructura como código, CI/CD, AWS, Azure, Google Cloud",
      color: "green",
    },
    {
      icon: <FiBox className="w-6 h-6" />,
      title: "Contenedores & Kubernetes",
      desc: "Docker, Kubernetes, Helm, Istio, microservicios",
      color: "purple",
    },
    {
      icon: <FiUsers className="w-6 h-6" />,
      title: "Gestión de Proyectos",
      desc: "Metodologías ágiles, Scrum, Kanban, liderazgo técnico",
      color: "orange",
    },
  ];

  const colorClasses = {
    blue: "bg-blue-100 text-blue-600 group-hover:bg-blue-600 group-hover:text-white",
    green: "bg-green-100 text-green-600 group-hover:bg-green-600 group-hover:text-white",
    purple: "bg-purple-100 text-purple-600 group-hover:bg-purple-600 group-hover:text-white",
    orange: "bg-orange-100 text-orange-600 group-hover:bg-orange-600 group-hover:text-white",
  };

  return (
    <section id="acerca" className="py-16 md:py-20 bg-gray-50">
      <div className="container px-4 mx-auto max-w-7xl">
        {/* Título */}
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-12">
          Acerca de Mí
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          {/* Columna izquierda: Info personal */}
          <div className="space-y-6">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3">
                Rafael Antonio Álvarez Vera
              </h3>
              <p className="text-gray-600 leading-relaxed text-base md:text-lg">
                Ingeniero en Sistemas Computacionales con pasión por el desarrollo de software y la tecnología. 
                Con experiencia en acompañar proyectos completos desde el diseño inicial hasta la implementación 
                final en producción.
              </p>
            </div>

            <p className="text-gray-600 leading-relaxed text-base md:text-lg">
              Me especializo en arquitecturas modernas, DevOps, contenedores con Docker y orquestación con 
              Kubernetes. Tengo experiencia en la gestión de infraestructura en la nube y asegurar la alta 
              disponibilidad y escalabilidad de las aplicaciones.
            </p>

         
          </div>

          {/* Columna derecha: Resumen profesional */}
          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-lg border border-gray-100">
            <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-6 flex items-center">
              <FiCheckCircle className="w-6 h-6 text-primary-600 mr-2" />
              Resumen Profesional
            </h3>

            <div className="space-y-5">
              {highlights.map((item, index) => (
                <div
                  key={index}
                  className="group flex items-start p-4 rounded-xl hover:bg-gray-50 transition-all duration-300"
                >
                  <div
                    className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                      colorClasses[item.color as keyof typeof colorClasses]
                    }`}
                  >
                    {item.icon}
                  </div>
                  <div className="ml-4 flex-1">
                    <h4 className="font-bold text-gray-800 text-lg group-hover:text-primary-700 transition-colors">
                      {item.title}
                    </h4>
                    <p className="text-gray-600 text-sm md:text-base mt-1">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;